export default {
      id: "color_tube_lilac-usage",
      viewBox: "0 0 44 126",
      url: __webpack_public_path__ + "sprite.svg#color_tube_lilac",
      toString: function () {
        return this.url;
      }
    }